export class Site {
  constructor(
    public siteId: string,
    public uid: string,
    public domain: string,
    public alternateDomains: string[],
    public title: string,
    public tagline: string,
    public accountId: string,
    public partnerId: string,
    public created: string,
    public updated: string,
    public stagingDomain: string,
    public template: boolean,
    public templateVersion: number,
  ) {}

  public getDomains(): string[] {
    return [this.domain].concat(this.alternateDomains);
  }
}

export interface SiteStatusResponseJSON {
  data: SiteStatusJSON;
}

interface SiteStatusJSON {
  site_id: string;
  status_code: string;
  available: boolean;
}

export class SiteStatus {
  public constructor(
    public siteId: string,
    public status: string,
    public available: boolean,
  ) {}

  public static fromJSON(json: SiteStatusJSON): SiteStatus {
    return new SiteStatus(json.site_id, json.status_code, json.available);
  }
}

export interface SiteUpdate {
  php_version: string;
  core_version: string;
  latest_core_version: string;
  num_of_plugin_updates: number;
  num_of_theme_updates: number;
}

export interface WspUpdatesResponse {
  'wsp/updates': SiteUpdate;
}

export interface SiteSettingFlagMessage {
  enabled: boolean;
}

export interface SiteSettingFlagResponse {
  data: SiteSettingFlagMessage;
}

export class SiteSettingFlagRequest {
  public constructor(public enabled: boolean) {}
}

export interface GaEnabledStateData {
  enabled: boolean;
}
export interface GaEnabledResponse {
  data: GaEnabledStateData;
}
